import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 71,
	height: 66.597,
	viewBox: "0 0 71 66.597",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon-folder",
		transform: "translate(-496 -273)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_3122",
			"data-name": "Path 3122",
			d: "M0,14.89V5.912A5.912,5.912,0,0,1,5.912,0H29.383L40.738,9.2Z",
			transform: "translate(496 273)",
			fill: "#d7d6db"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3123",
			"data-name": "Path 3123",
			d: "M65.088,19.4H5.912A5.911,5.911,0,0,0,0,25.31V70.881a5.911,5.911,0,0,0,5.912,5.912H65.088A5.911,5.911,0,0,0,71,70.881V25.31A5.911,5.911,0,0,0,65.088,19.4",
			transform: "translate(496 262.804)",
			fill: "#f7f6f8"
		})]
	})
});
export default SvgFolderIcon;
